import { _ as _objectSpread2, a as _createClass, b as _classCallCheck, c as _defineProperty, d as _asyncToGenerator, e as _regeneratorRuntime } from './wrapNativeSuper-88131596.esm.js';
import { subscribeWithSelector, persist } from 'zustand/middleware';
import create from 'zustand/vanilla';
import 'core-js/modules/es.array.concat.js';
import { d as defaultTranscodingProfiles, _ as _arrayLikeToArray, a as _unsupportedIterableToArray } from './unsupportedIterableToArray-4d074139.esm.js';
export { H as HttpError, b as defaultStudioConfig, d as defaultTranscodingProfiles } from './unsupportedIterableToArray-4d074139.esm.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.regexp.to-string.js';
import Hls, { Events, ErrorTypes } from 'hls.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.string.replace.js';
import fetch from 'cross-fetch';
import { createStitches, keyframes } from '@stitches/core';
import 'core-js/modules/es.object.get-prototype-of.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.number.is-integer.js';

var noopStorage = {
  getItem: function getItem(_key) {
    return '';
  },
  setItem: function setItem(_key, _value) {
    return null;
  },
  removeItem: function removeItem(_key) {
    return null;
  }
};
function createStorage(_ref) {
  var storage = _ref.storage,
      _ref$key = _ref.key,
      prefix = _ref$key === void 0 ? 'livepeer' : _ref$key;
  return _objectSpread2(_objectSpread2({}, storage), {}, {
    getItem: function getItem(key) {
      var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var value = storage.getItem("".concat(prefix, ".").concat(key));

      try {
        return value ? JSON.parse(value) : defaultState;
      } catch (error) {
        console.warn(error);
        return defaultState;
      }
    },
    setItem: function setItem(key, value) {
      if (value === null) {
        storage.removeItem("".concat(prefix, ".").concat(key));
      } else {
        try {
          storage.setItem("".concat(prefix, ".").concat(key), JSON.stringify(value));
        } catch (err) {
          console.error(err);
        }
      }
    },
    removeItem: function removeItem(key) {
      return storage.removeItem("".concat(prefix, ".").concat(key));
    }
  });
}

var storeKey = 'livepeer-store';
var Client = /*#__PURE__*/function () {
  function Client(_ref) {
    var provider = _ref.provider,
        _ref$storage = _ref.storage,
        storage = _ref$storage === void 0 ? createStorage({
      storage: typeof window !== 'undefined' ? window.localStorage : noopStorage
    }) : _ref$storage;

    _classCallCheck(this, Client);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "store", void 0);

    // Create store
    this.store = create(subscribeWithSelector(persist(function () {
      return {
        provider: provider()
      };
    }, {
      name: storeKey,
      getStorage: function getStorage() {
        return storage;
      },
      // for now, we don't store any state in local storage
      partialize: function partialize(_state) {
        return {};
      },
      version: 1
    })));
    this.config = {
      provider: provider,
      storage: storage
    };
    this.storage = storage;
  }

  _createClass(Client, [{
    key: "error",
    get: function get() {
      return this.store.getState().error;
    }
  }, {
    key: "provider",
    get: function get() {
      return this.store.getState().provider;
    }
  }, {
    key: "subscribe",
    get: function get() {
      return this.store.subscribe;
    }
  }, {
    key: "setState",
    value: function setState(updater) {
      var newState = typeof updater === 'function' ? updater(this.store.getState()) : updater;
      this.store.setState(newState, true);
    }
  }, {
    key: "clearState",
    value: function clearState() {
      this.setState(function (x) {
        return _objectSpread2(_objectSpread2({}, x), {}, {
          data: undefined,
          error: undefined
        });
      });
    }
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.clearState();
                this.store.destroy();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function destroy() {
        return _destroy.apply(this, arguments);
      }

      return destroy;
    }()
  }]);

  return Client;
}();
var client;
function createClient(config) {
  var client_ = new Client(config);
  client = client_;
  return client_;
}
function getClient() {
  if (!client) {
    throw new Error('No livepeer client found.');
  }

  return client;
}

function getLivepeerProvider() {
  var client = getClient();
  return client.provider;
}

function watchLivepeerProvider(callback) {
  var client = getClient();

  var handleChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", callback(getLivepeerProvider()));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange() {
      return _ref.apply(this, arguments);
    };
  }();

  var unsubscribe = client.subscribe(function (_ref2) {
    var provider = _ref2.provider;
    return provider;
  }, handleChange);
  return unsubscribe;
}

function createAsset(args) {
  var provider = getLivepeerProvider();
  return provider.createAsset(args);
}

function getAsset(args) {
  var provider = getLivepeerProvider();
  return provider.getAsset(args);
}

function updateAsset(args) {
  var provider = getLivepeerProvider();
  return provider.updateAsset(args);
}

function getAssetMetrics(args) {
  var provider = getLivepeerProvider();
  return provider.getAssetMetrics(args);
}

function getPlaybackInfo(args) {
  var provider = getLivepeerProvider();
  return provider.getPlaybackInfo(args);
}

function createStream(_ref) {
  var name = _ref.name,
      _ref$profiles = _ref.profiles,
      profiles = _ref$profiles === void 0 ? defaultTranscodingProfiles : _ref$profiles;
  var provider = getLivepeerProvider();
  return provider.createStream({
    name: name,
    profiles: profiles
  });
}

function getStream(args) {
  var provider = getLivepeerProvider();
  return provider.getStream(args);
}

function getStreamSession(args) {
  var provider = getLivepeerProvider();
  return provider.getStreamSession(args);
}

function getStreamSessions(args) {
  var provider = getLivepeerProvider();
  return provider.getStreamSessions(args);
}

function updateStream(args) {
  var provider = getLivepeerProvider();
  return provider.updateStream(args);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

// from https://github.com/voodoocreation/ts-deepmerge/blob/master/src/index.ts
// istanbul ignore next
var isObject = function isObject(obj) {
  if (_typeof(obj) === 'object' && obj !== null) {
    if (typeof Object.getPrototypeOf === 'function') {
      var prototype = Object.getPrototypeOf(obj);
      return prototype === Object.prototype || prototype === null;
    }

    return Object.prototype.toString.call(obj) === '[object Object]';
  }

  return false;
};

var merge = function merge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (result, current) {
    if (Array.isArray(current)) {
      throw new TypeError('Arguments provided to ts-deepmerge must be objects, not arrays.');
    }

    Object.keys(current).forEach(function (key) {
      if (['__proto__', 'constructor', 'prototype'].includes(key)) {
        return;
      }

      if (Array.isArray(result[key]) && Array.isArray(current[key])) {
        result[key] = merge.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
      } else if (isObject(result[key]) && isObject(current[key])) {
        result[key] = merge(result[key], current[key]);
      } else {
        result[key] = current[key];
      }
    });
    return result;
  }, {});
};

var defaultOptions = {
  mergeArrays: true
};
merge.options = defaultOptions;

merge.withOptions = function (options) {
  merge.options = _objectSpread2({
    mergeArrays: true
  }, options);

  for (var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    objects[_key2 - 1] = arguments[_key2];
  }

  var result = merge.apply(void 0, objects);
  merge.options = defaultOptions;
  return result;
};

var deepMerge = merge;

var pick = function pick(obj, keys) {
  try {
    var objectKeys = Object.keys(obj);
    return keys.filter(function (key) {
      return objectKeys.includes(key);
    }).reduce(function (prev, curr) {
      return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, curr, obj[curr]));
    }, {});
  } catch (e) {
    throw new Error('Could not pick keys for object.');
  }
};

var noop = function noop() {//
};

var _window, _window$navigator, _window$navigator$use, _window2, _window2$navigator, _window3, _window4, _window5, _window5$location, _window6, _window6$location, _window7, _window7$location;
var IS_CLIENT = typeof window !== 'undefined';
var UA = IS_CLIENT ? (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase() : '';
var IS_IOS = /iphone|ipad|ipod|ios|CriOS|FxiOS/.test(UA);
var IS_ANDROID = /android/.test(UA);
var IS_MOBILE = IS_CLIENT && (IS_IOS || IS_ANDROID);
IS_CLIENT && /(iPhone|iPod)/gi.test((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.platform);
/firefox/.test(UA);
var IS_CHROME = IS_CLIENT && !!((_window3 = window) !== null && _window3 !== void 0 && _window3.chrome);
IS_CLIENT && !IS_CHROME && (((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.safari) || IS_IOS || /(apple|safari)/.test(UA));
IS_CLIENT && (_window5 = window) !== null && _window5 !== void 0 && (_window5$location = _window5.location) !== null && _window5$location !== void 0 && _window5$location.protocol && ((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$location = _window6.location) === null || _window6$location === void 0 ? void 0 : _window6$location.protocol) !== 'file:' && (_window7 = window) !== null && _window7 !== void 0 && (_window7$location = _window7.location) !== null && _window7$location !== void 0 && _window7$location.hostname ? "".concat(window.location.protocol, "//").concat(window.location.hostname) : undefined;
/**
 * Checks if the native HTML5 video player can play the mime type.
 */

var canPlayMediaNatively = function canPlayMediaNatively(type) {
  if (IS_CLIENT) {
    // TODO fix this to better support audio mime types
    if (type.includes('audio')) {
      var audio = document.createElement('audio');
      return audio.canPlayType(type).length > 0;
    } else {
      var video = document.createElement('video');
      return video.canPlayType(type).length > 0;
    }
  }

  return true;
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var methodsList = [// modern browsers
{
  requestFullscreen: 'requestFullscreen',
  exitFullscreen: 'exitFullscreen',
  fullscreenElement: 'fullscreenElement',
  fullscreenEnabled: 'fullscreenEnabled',
  fullscreenchange: 'fullscreenchange',
  fullscreenerror: 'fullscreenerror'
}, // new WebKit
{
  requestFullscreen: 'webkitRequestFullscreen',
  exitFullscreen: 'webkitExitFullscreen',
  fullscreenElement: 'webkitFullscreenElement',
  fullscreenEnabled: 'webkitFullscreenEnabled',
  fullscreenchange: 'webkitfullscreenchange',
  fullscreenerror: 'webkitfullscreenerror'
}, // old WebKit
{
  requestFullscreen: 'webkitRequestFullScreen',
  exitFullscreen: 'webkitCancelFullScreen',
  fullscreenElement: 'webkitCurrentFullScreenElement',
  fullscreenEnabled: 'webkitCancelFullScreen',
  fullscreenchange: 'webkitfullscreenchange',
  fullscreenerror: 'webkitfullscreenerror'
}, // old firefox
{
  requestFullscreen: 'mozRequestFullScreen',
  exitFullscreen: 'mozCancelFullScreen',
  fullscreenElement: 'mozFullScreenElement',
  fullscreenEnabled: 'mozFullScreenEnabled',
  fullscreenchange: 'mozfullscreenchange',
  fullscreenerror: 'mozfullscreenerror'
}, // old IE
{
  requestFullscreen: 'msRequestFullscreen',
  exitFullscreen: 'msExitFullscreen',
  fullscreenElement: 'msFullscreenElement',
  fullscreenEnabled: 'msFullscreenEnabled',
  fullscreenchange: 'MSFullscreenChange',
  fullscreenerror: 'MSFullscreenError'
}]; // iOS API (on the video element itself!)

var iosMethods = {
  requestFullscreen: 'webkitEnterFullscreen',
  exitFullscreen: 'webkitExitFullscreen',
  fullscreenElement: null,
  fullscreenEnabled: 'webkitDisplayingFullscreen',
  fullscreenchange: 'fullscreenchange',
  fullscreenerror: 'fullscreenerror'
};
var isCurrentlyFullscreen = function isCurrentlyFullscreen(inputElement) {
  var _getFullscreenMethods = getFullscreenMethods(inputElement),
      methods = _getFullscreenMethods.methods;

  if (methods !== null && methods !== void 0 && methods.fullscreenElement) {
    return Boolean(document[methods.fullscreenElement]);
  }

  return false;
};
var enterFullscreen = function enterFullscreen(inputElement) {
  var _getFullscreenMethods2 = getFullscreenMethods(inputElement),
      methods = _getFullscreenMethods2.methods,
      element = _getFullscreenMethods2.element;

  if (methods) {
    return new Promise(function (resolve, reject) {
      var _element$parentElemen, _element$parentElemen2, _element$fullscreenMe, _element$fullscreenMe2;

      var fullscreenMethod = methods.requestFullscreen;

      var onFullScreen = function onFullScreen() {
        removeFullscreenEventListener(onFullScreen);
        resolve();
      };

      addFullscreenEventListener(onFullScreen);
      var returnPromise = methods.fullscreenElement ? element === null || element === void 0 ? void 0 : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : (_element$parentElemen2 = _element$parentElemen[fullscreenMethod]) === null || _element$parentElemen2 === void 0 ? void 0 : _element$parentElemen2.call(_element$parentElemen) : (_element$fullscreenMe = element === null || element === void 0 ? void 0 : (_element$fullscreenMe2 = element[fullscreenMethod]) === null || _element$fullscreenMe2 === void 0 ? void 0 : _element$fullscreenMe2.call(element)) !== null && _element$fullscreenMe !== void 0 ? _element$fullscreenMe : null;

      if (returnPromise === null) {
        return resolve();
      }

      if (returnPromise instanceof Promise) {
        returnPromise.then(onFullScreen).catch(reject);
      }
    });
  }

  return false;
};
var exitFullscreen = function exitFullscreen(inputElement) {
  var _getFullscreenMethods3 = getFullscreenMethods(inputElement),
      methods = _getFullscreenMethods3.methods,
      element = _getFullscreenMethods3.element;

  if (methods) {
    return new Promise(function (resolve, reject) {
      var _document, _document$methods$exi, _element$methods$exit, _element$methods$exit2;

      if (!isCurrentlyFullscreen()) {
        resolve();
        return;
      }

      var onFullScreenExit = function onFullScreenExit() {
        removeFullscreenEventListener(onFullScreenExit);
        resolve();
      };

      addFullscreenEventListener(onFullScreenExit);
      var returnPromise = methods.fullscreenElement ? (_document = document) === null || _document === void 0 ? void 0 : (_document$methods$exi = _document[methods.exitFullscreen]) === null || _document$methods$exi === void 0 ? void 0 : _document$methods$exi.call(_document) : (_element$methods$exit = element === null || element === void 0 ? void 0 : (_element$methods$exit2 = element[methods.exitFullscreen]) === null || _element$methods$exit2 === void 0 ? void 0 : _element$methods$exit2.call(element)) !== null && _element$methods$exit !== void 0 ? _element$methods$exit : null;

      if (returnPromise instanceof Promise) {
        returnPromise.then(onFullScreenExit).catch(reject);
      }
    });
  }

  return false;
};
var addFullscreenEventListener = function addFullscreenEventListener(callback) {
  var _getFullscreenMethods4 = getFullscreenMethods(),
      methods = _getFullscreenMethods4.methods;

  if (methods) {
    document.addEventListener(methods.fullscreenchange, callback, false);
    return function () {
      removeFullscreenEventListener(callback);
    };
  }

  return null;
};

var removeFullscreenEventListener = function removeFullscreenEventListener(callback) {
  var _getFullscreenMethods5 = getFullscreenMethods(),
      methods = _getFullscreenMethods5.methods;

  if (methods) {
    document.removeEventListener(methods.fullscreenchange, callback, false);
    return true;
  }

  return false;
};

var getFullscreenMethods = function getFullscreenMethods(element) {
  if (IS_CLIENT) {
    var _iterator = _createForOfIteratorHelper(methodsList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var methods = _step.value;
        var exitFullscreenMethod = methods.exitFullscreen;

        if (exitFullscreenMethod in document) {
          return {
            methods: methods,
            element: element
          };
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (element && iosMethods.requestFullscreen in element) {
      return {
        methods: iosMethods,
        element: element
      };
    }
  }

  return {
    methods: null
  };
};

var MEDIA_CONTROLLER_INITIALIZED_ATTRIBUTE = 'data-controller-initialized';
var allKeyTriggers = ['KeyF', 'KeyK', 'KeyM', 'Space', 'ArrowRight', 'ArrowLeft'];
var DEFAULT_SEEK_TIME = 5000; // milliseconds which the media will skip when seeking with arrows/buttons

var DEFAULT_AUTOHIDE_TIME = 3000; // milliseconds to wait before hiding controls

var DEFAULT_VOLUME_LEVEL = 0.2; // 0-1 for how loud the audio is

var getFilteredNaN = function getFilteredNaN(value) {
  return value && !isNaN(value) && isFinite(value) ? value : 0;
};

var getBoundedSeek = function getBoundedSeek(seek, duration) {
  return Math.min(Math.max(0, getFilteredNaN(seek)), // seek to near the end
  getFilteredNaN(duration) ? getFilteredNaN(duration) - 0.01 : 0);
};

var getBoundedVolume = function getBoundedVolume(volume) {
  return Math.min(Math.max(0, getFilteredNaN(volume)), 1);
}; // if volume change is unsupported, the element will always return 1
// similar to https://github.com/videojs/video.js/pull/7514/files


var getIsVolumeChangeSupported = function getIsVolumeChangeSupported(element) {
  return new Promise(function (resolve) {
    var _element$volume;

    var prevVolume = (_element$volume = element === null || element === void 0 ? void 0 : element.volume) !== null && _element$volume !== void 0 ? _element$volume : DEFAULT_VOLUME_LEVEL;
    var newVolume = prevVolume - 0.01; // set new value and test

    element.volume = newVolume;
    window.setTimeout(function () {
      var isSupported = element.volume !== 1; // reset to old value

      element.volume = prevVolume;
      resolve(isSupported);
    });
  });
};

var createControllerStore = function createControllerStore(element) {
  var store = create(persist(function (set, get) {
    var _element$volume2, _ref, _element$muted;

    return {
      _element: element,
      canPlay: false,
      hidden: false,
      live: false,
      hasPlayed: false,
      playing: !(element !== null && element !== void 0 && element.paused),
      fullscreen: false,
      device: {
        isMobile: IS_MOBILE,
        isIos: IS_IOS,
        isAndroid: IS_ANDROID
      },
      progress: getFilteredNaN(element === null || element === void 0 ? void 0 : element.currentTime),
      duration: getFilteredNaN(element === null || element === void 0 ? void 0 : element.duration),
      buffered: 0,
      volume: (_element$volume2 = element === null || element === void 0 ? void 0 : element.volume) !== null && _element$volume2 !== void 0 ? _element$volume2 : DEFAULT_VOLUME_LEVEL,
      muted: (_ref = (_element$muted = element === null || element === void 0 ? void 0 : element.muted) !== null && _element$muted !== void 0 ? _element$muted : element === null || element === void 0 ? void 0 : element.defaultMuted) !== null && _ref !== void 0 ? _ref : true,
      isVolumeChangeSupported: false,
      _lastInteraction: Date.now(),
      _requestedRangeToSeekTo: 0,
      _requestedFullscreenLastTime: Date.now(),
      setHidden: function setHidden(hidden) {
        return set(function (_ref2) {
          var playing = _ref2.playing;
          return {
            hidden: playing ? hidden : false
          };
        });
      },
      _updateLastInteraction: function _updateLastInteraction() {
        return set(function () {
          return {
            _lastInteraction: Date.now()
          };
        });
      },
      onCanPlay: function onCanPlay() {
        return set(function () {
          return {
            canPlay: true
          };
        });
      },
      onPlay: function onPlay() {
        return set(function () {
          return {
            playing: true,
            _lastInteraction: Date.now(),
            hasPlayed: true
          };
        });
      },
      onPause: function onPause() {
        return set(function () {
          return {
            playing: false,
            hidden: false
          };
        });
      },
      togglePlay: function togglePlay() {
        return set(function (_ref3) {
          var playing = _ref3.playing;
          return {
            playing: !playing
          };
        });
      },
      onProgress: function onProgress(time) {
        return set(function () {
          return {
            progress: getFilteredNaN(time)
          };
        });
      },
      requestSeek: function requestSeek(time) {
        return set(function (_ref4) {
          var duration = _ref4.duration;
          return {
            _requestedRangeToSeekTo: getBoundedSeek(time, duration),
            progress: getBoundedSeek(time, duration)
          };
        });
      },
      onDurationChange: function onDurationChange(duration) {
        return set(function (_ref5) {
          var live = _ref5.live;
          return {
            duration: duration,
            live: duration === Number.POSITIVE_INFINITY ? true : live
          };
        });
      },
      _updateBuffered: function _updateBuffered(buffered) {
        return set(function () {
          return {
            buffered: buffered
          };
        });
      },
      _requestSeekDiff: function _requestSeekDiff(difference) {
        return set(function (_ref6) {
          var _element$currentTime;

          var duration = _ref6.duration;
          return {
            _requestedRangeToSeekTo: getBoundedSeek(getFilteredNaN((_element$currentTime = element === null || element === void 0 ? void 0 : element.currentTime) !== null && _element$currentTime !== void 0 ? _element$currentTime : 0) + difference / 1000, duration)
          };
        });
      },
      requestSeekBack: function requestSeekBack() {
        var difference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SEEK_TIME;
        return get()._requestSeekDiff(-difference);
      },
      requestSeekForward: function requestSeekForward() {
        var difference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SEEK_TIME;
        return get()._requestSeekDiff(difference);
      },
      setFullscreen: function setFullscreen(fullscreen) {
        return set(function () {
          return {
            fullscreen: fullscreen
          };
        });
      },
      requestToggleFullscreen: function requestToggleFullscreen() {
        return set(function () {
          return {
            _requestedFullscreenLastTime: Date.now()
          };
        });
      },
      setLive: function setLive(live) {
        return set(function () {
          return {
            live: live
          };
        });
      },
      requestVolume: function requestVolume(newVolume) {
        return set(function (_ref7) {
          var volume = _ref7.volume;
          return {
            volume: newVolume === 0 ? volume : getBoundedVolume(newVolume),
            muted: newVolume === 0
          };
        });
      },
      _setVolume: function _setVolume(newVolume) {
        return set(function () {
          return {
            volume: getBoundedVolume(newVolume)
          };
        });
      },
      requestToggleMute: function requestToggleMute() {
        return set(function (_ref8) {
          var muted = _ref8.muted;
          return {
            muted: !muted
          };
        });
      },
      setIsVolumeChangeSupported: function setIsVolumeChangeSupported(supported) {
        return set(function () {
          return {
            isVolumeChangeSupported: supported
          };
        });
      }
    };
  }, {
    name: 'livepeer-player',
    version: 1,
    // since these values are persisted across media elements, only persist volume
    partialize: function partialize(_ref9) {
      var volume = _ref9.volume;
      return {
        volume: volume
      };
    }
  }));
  var initializedState = store.getState(); // restore the persisted values from store

  if (element && !element.muted && !element.defaultMuted) {
    element.volume = initializedState.volume;
  }

  return store;
};

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var addEventListeners = function addEventListeners(store) {
  var _store$getState;

  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref10$hotkeys = _ref10.hotkeys,
      hotkeys = _ref10$hotkeys === void 0 ? true : _ref10$hotkeys,
      _ref10$autohide = _ref10.autohide,
      autohide = _ref10$autohide === void 0 ? DEFAULT_AUTOHIDE_TIME : _ref10$autohide;

  var element = store === null || store === void 0 ? void 0 : (_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : _store$getState._element;

  var onCanPlay = function onCanPlay() {
    return store.getState().onCanPlay();
  };

  var onPlay = function onPlay() {
    return store.getState().onPlay();
  };

  var onPause = function onPause() {
    return store.getState().onPause();
  };

  var onDurationChange = function onDurationChange() {
    var _element$duration;

    return store.getState().onDurationChange((_element$duration = element === null || element === void 0 ? void 0 : element.duration) !== null && _element$duration !== void 0 ? _element$duration : 0);
  };

  var onTimeUpdate = function onTimeUpdate() {
    var _element$currentTime2;

    return store.getState().onProgress((_element$currentTime2 = element === null || element === void 0 ? void 0 : element.currentTime) !== null && _element$currentTime2 !== void 0 ? _element$currentTime2 : 0);
  };

  var onKeyUp = function onKeyUp(e) {
    e.preventDefault();
    e.stopPropagation();
    var code = e.code;

    store.getState()._updateLastInteraction();

    if (allKeyTriggers.includes(code)) {
      if (code === 'Space' || code === 'KeyK') {
        store.getState().togglePlay();
      } else if (code === 'KeyF') {
        store.getState().requestToggleFullscreen();
      } else if (code === 'ArrowRight') {
        store.getState().requestSeekForward();
      } else if (code === 'ArrowLeft') {
        store.getState().requestSeekBack();
      } else if (code === 'KeyM') {
        store.getState().requestToggleMute();
      }
    }
  };

  var onMouseEnter = function onMouseEnter() {
    store.getState()._updateLastInteraction();
  };

  var onMouseLeave = function onMouseLeave() {
    if (autohide) {
      store.getState().setHidden(true);
    }
  };

  var onMouseMove = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.getState()._updateLastInteraction();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onMouseMove() {
      return _ref11.apply(this, arguments);
    };
  }();

  var onTouchUpdate = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              store.getState()._updateLastInteraction();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onTouchUpdate() {
      return _ref12.apply(this, arguments);
    };
  }();

  var onVolumeChange = function onVolumeChange() {
    if (typeof (element === null || element === void 0 ? void 0 : element.volume) !== 'undefined' && (element === null || element === void 0 ? void 0 : element.volume) !== store.getState().volume) {
      store.getState()._setVolume(element.volume);
    }
  };

  var onProgress = function onProgress() {
    var _element$duration2;

    if (element && ((_element$duration2 = element === null || element === void 0 ? void 0 : element.duration) !== null && _element$duration2 !== void 0 ? _element$duration2 : 0) > 0) {
      var _store$getState$durat, _store$getState2, _store$getState2$call;

      var currentTime = element.currentTime;

      var _buffered = _toConsumableArray(Array(element.buffered.length)).reduce(function (prev, _curr, i) {
        var start = element.buffered.start(element.buffered.length - 1 - i);
        var end = element.buffered.end(element.buffered.length - 1 - i); // if the TimeRange covers the current time, then use this value

        if (start <= currentTime && end >= currentTime) {
          return end;
        }

        return prev;
      }, // default to end of media
      (_store$getState$durat = store === null || store === void 0 ? void 0 : (_store$getState2 = store.getState) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$call = _store$getState2.call(store)) === null || _store$getState2$call === void 0 ? void 0 : _store$getState2$call.duration) !== null && _store$getState$durat !== void 0 ? _store$getState$durat : 0);

      store.getState()._updateBuffered(_buffered);
    }
  };

  var retryCount = 0;

  var onError = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return new Promise(function (r) {
                return setTimeout(r, 1000 * ++retryCount);
              });

            case 2:
              element === null || element === void 0 ? void 0 : element.load();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onError() {
      return _ref13.apply(this, arguments);
    };
  }();

  if (element) {
    var _element$parentElemen;

    element.addEventListener('volumechange', onVolumeChange);
    element.addEventListener('canplay', onCanPlay);
    element.addEventListener('play', onPlay);
    element.addEventListener('pause', onPause);
    element.addEventListener('durationchange', onDurationChange);
    element.addEventListener('timeupdate', onTimeUpdate);
    element.addEventListener('progress', onProgress);
    element.addEventListener('error', onError);
    var parentElementOrElement = (_element$parentElemen = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _element$parentElemen !== void 0 ? _element$parentElemen : element;

    if (hotkeys) {
      parentElementOrElement.addEventListener('keyup', onKeyUp);
    }

    if (autohide) {
      parentElementOrElement.addEventListener('mouseenter', onMouseEnter);
      parentElementOrElement.addEventListener('mouseleave', onMouseLeave);
      parentElementOrElement.addEventListener('mousemove', onMouseMove);
      parentElementOrElement.addEventListener('touchstart', onTouchUpdate);
      parentElementOrElement.addEventListener('touchend', onTouchUpdate);
      parentElementOrElement.addEventListener('touchmove', onTouchUpdate);
    }

    element.load();
    getIsVolumeChangeSupported(element).then(function (isVolumeChangeSupported) {
      return store.getState().setIsVolumeChangeSupported(isVolumeChangeSupported);
    });
    element.setAttribute(MEDIA_CONTROLLER_INITIALIZED_ATTRIBUTE, 'true');
  }

  var onFullScreenChange = function onFullScreenChange(e) {
    var _e$target, _e$target$contains;

    var isFullscreenElementPresent = isCurrentlyFullscreen(element);
    var eventTargetIncludesElement = Boolean(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$contains = _e$target.contains) === null || _e$target$contains === void 0 ? void 0 : _e$target$contains.call(_e$target, element));

    if (eventTargetIncludesElement) {
      store.getState().setFullscreen(Boolean(isFullscreenElementPresent));
    }
  }; // add effects


  var removeEffectsFromStore = addEffectsToStore(store, element, {
    autohide: autohide
  }); // add fullscreen listener

  var removeFullscreenListener = addFullscreenEventListener(onFullScreenChange);
  return {
    destroy: function destroy() {
      var _element$removeEventL, _element$removeEventL2, _element$removeEventL3, _element$removeEventL4, _element$removeEventL5, _element$removeEventL6, _element$parentElemen2, _parentElementOrEleme, _parentElementOrEleme2, _parentElementOrEleme3, _parentElementOrEleme4, _parentElementOrEleme5, _parentElementOrEleme6, _parentElementOrEleme7, _store$destroy, _element$removeAttrib;

      removeFullscreenListener === null || removeFullscreenListener === void 0 ? void 0 : removeFullscreenListener();
      element === null || element === void 0 ? void 0 : (_element$removeEventL = element.removeEventListener) === null || _element$removeEventL === void 0 ? void 0 : _element$removeEventL.call(element, 'canplay', onCanPlay);
      element === null || element === void 0 ? void 0 : (_element$removeEventL2 = element.removeEventListener) === null || _element$removeEventL2 === void 0 ? void 0 : _element$removeEventL2.call(element, 'play', onPlay);
      element === null || element === void 0 ? void 0 : (_element$removeEventL3 = element.removeEventListener) === null || _element$removeEventL3 === void 0 ? void 0 : _element$removeEventL3.call(element, 'pause', onPause);
      element === null || element === void 0 ? void 0 : (_element$removeEventL4 = element.removeEventListener) === null || _element$removeEventL4 === void 0 ? void 0 : _element$removeEventL4.call(element, 'durationchange', onDurationChange);
      element === null || element === void 0 ? void 0 : (_element$removeEventL5 = element.removeEventListener) === null || _element$removeEventL5 === void 0 ? void 0 : _element$removeEventL5.call(element, 'timeupdate', onTimeUpdate);
      element === null || element === void 0 ? void 0 : (_element$removeEventL6 = element.removeEventListener) === null || _element$removeEventL6 === void 0 ? void 0 : _element$removeEventL6.call(element, 'progress', onProgress);
      var parentElementOrElement = (_element$parentElemen2 = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _element$parentElemen2 !== void 0 ? _element$parentElemen2 : element;
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme === void 0 ? void 0 : _parentElementOrEleme.call(parentElementOrElement, 'keyup', onKeyUp);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme2 = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme2 === void 0 ? void 0 : _parentElementOrEleme2.call(parentElementOrElement, 'mouseenter', onMouseEnter);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme3 = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme3 === void 0 ? void 0 : _parentElementOrEleme3.call(parentElementOrElement, 'mouseleave', onMouseLeave);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme4 = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme4 === void 0 ? void 0 : _parentElementOrEleme4.call(parentElementOrElement, 'mousemove', onMouseMove);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme5 = parentElementOrElement.addEventListener) === null || _parentElementOrEleme5 === void 0 ? void 0 : _parentElementOrEleme5.call(parentElementOrElement, 'touchstart', onTouchUpdate);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme6 = parentElementOrElement.addEventListener) === null || _parentElementOrEleme6 === void 0 ? void 0 : _parentElementOrEleme6.call(parentElementOrElement, 'touchend', onTouchUpdate);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme7 = parentElementOrElement.addEventListener) === null || _parentElementOrEleme7 === void 0 ? void 0 : _parentElementOrEleme7.call(parentElementOrElement, 'touchmove', onTouchUpdate);
      removeEffectsFromStore === null || removeEffectsFromStore === void 0 ? void 0 : removeEffectsFromStore();
      store === null || store === void 0 ? void 0 : (_store$destroy = store.destroy) === null || _store$destroy === void 0 ? void 0 : _store$destroy.call(store);
      element === null || element === void 0 ? void 0 : (_element$removeAttrib = element.removeAttribute) === null || _element$removeAttrib === void 0 ? void 0 : _element$removeAttrib.call(element, MEDIA_CONTROLLER_INITIALIZED_ATTRIBUTE);
    }
  };
};
var previousPromise;

var addEffectsToStore = function addEffectsToStore(store, element, options) {
  // add effects to store changes
  return store.subscribe( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(current, prev) {
      var isFullscreen;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!element) {
                _context4.next = 19;
                break;
              }

              if (!previousPromise) {
                _context4.next = 9;
                break;
              }

              _context4.prev = 2;
              _context4.next = 5;
              return previousPromise;

            case 5:
              _context4.next = 9;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](2);

            case 9:
              if (current.playing !== prev.playing) {
                if (current.playing) {
                  previousPromise = element.play();
                } else {
                  element.pause();
                }
              }

              if (current.volume !== prev.volume) {
                element.volume = current.volume;
              }

              if (current.muted !== prev.muted) {
                element.muted = current.muted;

                if (current.volume === 0) {
                  element.volume = DEFAULT_VOLUME_LEVEL;
                }
              }

              if (current._requestedRangeToSeekTo !== prev._requestedRangeToSeekTo) {
                // Can't set the time before the media is ready
                // Ignore if readyState isn't supported
                if (typeof element.readyState === 'undefined' || element.readyState > 0) {
                  element.currentTime = current._requestedRangeToSeekTo;
                }
              } // user has interacted with element


              if (!(options.autohide && current._lastInteraction !== prev._lastInteraction)) {
                _context4.next = 18;
                break;
              }

              store.getState().setHidden(false);
              _context4.next = 17;
              return delay(options.autohide);

            case 17:
              if (!store.getState().hidden && current._lastInteraction === store.getState()._lastInteraction) {
                store.getState().setHidden(true);
              }

            case 18:
              if (current._requestedFullscreenLastTime !== prev._requestedFullscreenLastTime) {
                isFullscreen = isCurrentlyFullscreen(element);

                if (!isFullscreen) {
                  previousPromise = enterFullscreen(element);
                } else {
                  previousPromise = exitFullscreen(element);
                }
              }

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 7]]);
    }));

    return function (_x, _x2) {
      return _ref14.apply(this, arguments);
    };
  }());
};

var PlaybackMonitor = /*#__PURE__*/function () {
  function PlaybackMonitor(element) {
    _classCallCheck(this, PlaybackMonitor);

    _defineProperty(this, "active", false);

    _defineProperty(this, "values", []);

    _defineProperty(this, "score", null);

    _defineProperty(this, "averagingSteps", 20);

    _defineProperty(this, "element", void 0);

    this.element = element;
  }

  _createClass(PlaybackMonitor, [{
    key: "init",
    value: function init() {
      if (!this.active) {
        this.values = [];
        this.score = null;
        this.active = true;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this.active) {
        // it's not running, start it up
        this.init();
      } else {
        this.values = [];
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.active) {
        this.values = [];
        this.score = null;
        this.active = false;
      }
    }
  }, {
    key: "calculateScore",
    value: function calculateScore() {
      if (this.active) {
        // save the current testing value and time
        // If the media plays, this should keep a constant value. If the media is stalled, it will go up with 1sec/sec. If the media is playing faster, it will go down.
        // current clock time - current playback time
        var latestPlaybackRecord = this.values.length > 0 ? this.values[this.values.length - 1] : undefined;
        var currentValue = {
          clockTime: Date.now() * 1e-3,
          mediaTime: this.element.currentTime,
          score: latestPlaybackRecord ? this.valueToScore(latestPlaybackRecord) : 0
        };
        this.values.push(currentValue); // add the current value to the history
        // no history yet, can't calculate a score

        if (this.values.length < 2) {
          return null;
        }

        var oldestValue = this.values[0];

        if (oldestValue !== undefined && currentValue !== undefined) {
          // diff between oldest score and current
          var averagedScore = this.valueToScore(oldestValue, currentValue); // should be 1, decreases if bad
          // kick the oldest value from the array

          if (this.values.length > this.averagingSteps) {
            this.values.shift();
          } // the final score is the maximum of the averaged and the current value


          this.score = Math.max(averagedScore, currentValue.score);
          return Math.round(this.score * 10) / 10;
        }
      }

      return null;
    }
  }, {
    key: "valueToScore",
    value: function valueToScore(a, b) {
      var _this$element, _b$mediaTime, _b$clockTime;

      // calculate the moving average
      // if this returns > 1, the media played faster than the clock
      // if this returns < 0, the media time went backwards
      var rate = this !== null && this !== void 0 && (_this$element = this.element) !== null && _this$element !== void 0 && _this$element.playbackRate ? this.element.playbackRate : 1;
      return ((_b$mediaTime = b === null || b === void 0 ? void 0 : b.mediaTime) !== null && _b$mediaTime !== void 0 ? _b$mediaTime : this.element.currentTime - a.mediaTime) / ((_b$clockTime = b === null || b === void 0 ? void 0 : b.clockTime) !== null && _b$clockTime !== void 0 ? _b$clockTime : Date.now() * 1e-3 - a.clockTime) / rate;
    }
  }]);

  return PlaybackMonitor;
}();
var MetricsStatus = /*#__PURE__*/function () {
  function MetricsStatus(element) {
    var _this = this;

    _classCallCheck(this, MetricsStatus);

    _defineProperty(this, "retryCount", 0);

    _defineProperty(this, "connected", false);

    _defineProperty(this, "element", void 0);

    _defineProperty(this, "currentMetrics", void 0);

    _defineProperty(this, "previousMetrics", null);

    _defineProperty(this, "timeWaiting", 0);

    _defineProperty(this, "waitingSince", 0);

    _defineProperty(this, "timeStalled", 0);

    _defineProperty(this, "stalledSince", 0);

    _defineProperty(this, "timeUnpaused", 0);

    _defineProperty(this, "unpausedSince", 0);

    this.element = element;
    this.currentMetrics = {
      firstPlayback: 0,
      nWaiting: 0,
      timeWaiting: 0,
      nStalled: 0,
      timeStalled: 0,
      timeUnpaused: 0,
      nError: 0,
      videoHeight: null,
      videoWidth: null,
      playerHeight: null,
      playerWidth: null,
      player: 'generic',
      pageUrl: '',
      sourceUrl: '',
      playbackScore: null,
      duration: null
    };
    element.addEventListener('waiting', function () {
      _this.timeWaiting = _this._getTimeWaiting(); // in case we get waiting several times in a row

      _this.waitingSince = Date.now();
    });
    element.addEventListener('stalled', function () {
      _this.timeStalled = _this._getTimeStalled(); // in case we get stalled several times in a row

      _this.stalledSince = Date.now();
    });

    var _iterator = _createForOfIteratorHelper(['playing', 'pause']),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var event = _step.value;
        element.addEventListener(event, function () {
          _this.timeWaiting = _this._getTimeWaiting();
          _this.timeStalled = _this._getTimeStalled();
          _this.waitingSince = 0;
          _this.stalledSince = 0;
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    element.addEventListener('playing', function () {
      _this.timeUnpaused = _this._getTimeUnpaused(); // in case we get playing several times in a row

      _this.unpausedSince = Date.now();
    });
    element.addEventListener('pause', function () {
      _this.timeUnpaused = _this._getTimeUnpaused();
      _this.unpausedSince = 0;
    });
  }

  _createClass(MetricsStatus, [{
    key: "_getTimeWaiting",
    value: function _getTimeWaiting() {
      return this.timeWaiting + (this.waitingSince ? Date.now() - this.waitingSince : 0);
    }
  }, {
    key: "_getTimeStalled",
    value: function _getTimeStalled() {
      return this.timeStalled + (this.stalledSince ? Date.now() - this.stalledSince : 0);
    }
  }, {
    key: "_getTimeUnpaused",
    value: function _getTimeUnpaused() {
      return this.timeUnpaused + (this.unpausedSince ? Date.now() - this.unpausedSince : 0);
    }
  }, {
    key: "addError",
    value: function addError(error) {
      this.currentMetrics.nError++;
      this.currentMetrics.lastError = error;
    }
  }, {
    key: "incrementStalled",
    value: function incrementStalled() {
      this.currentMetrics.nStalled++;
    }
  }, {
    key: "incrementWaiting",
    value: function incrementWaiting() {
      this.currentMetrics.nWaiting++;
    }
  }, {
    key: "setFirstPlayback",
    value: function setFirstPlayback() {
      this.currentMetrics.firstPlayback = Date.now() - bootMs;
    }
  }, {
    key: "setPlaybackScore",
    value: function setPlaybackScore(playbackScore) {
      this.currentMetrics.playbackScore = playbackScore;
    }
  }, {
    key: "setConnected",
    value: function setConnected(isConnected) {
      this.connected = isConnected;
    }
  }, {
    key: "getMetrics",
    value: function getMetrics() {
      var _this$element2, _this$element3, _this$element4, _this$element5;

      var currentMetrics = _objectSpread2(_objectSpread2({}, this.currentMetrics), {}, {
        playerHeight: this.element ? this.element.clientHeight : null,
        playerWidth: this.element ? this.element.clientWidth : null,
        videoWidth: (_this$element2 = this.element) !== null && _this$element2 !== void 0 && _this$element2.videoWidth ? (_this$element3 = this.element) === null || _this$element3 === void 0 ? void 0 : _this$element3.videoWidth : null,
        videoHeight: (_this$element4 = this.element) !== null && _this$element4 !== void 0 && _this$element4.videoHeight ? (_this$element5 = this.element) === null || _this$element5 === void 0 ? void 0 : _this$element5.videoHeight : null,
        duration: this.element.duration,
        timeWaiting: this._getTimeWaiting(),
        timeStalled: this._getTimeStalled(),
        timeUnpaused: this._getTimeUnpaused()
      });

      var previousMetrics = this.previousMetrics;
      this.previousMetrics = currentMetrics;
      return {
        current: currentMetrics,
        previous: previousMetrics
      };
    }
  }]);

  return MetricsStatus;
}();
var bootMs = Date.now(); // used for firstPlayback value

var VIDEO_METRICS_INITIALIZED_ATTRIBUTE = 'data-metrics-initialized';

/**
 * Gather playback metrics from a generic HTML5 video (or audio) element and
 * report those back to a websocket.
 * @param element                 Element to capture playback metrics from
 * @param reportingWebsocketUrl   URL to the websocket to report to
 */
function reportMediaMetrics(element, reportingWebsocketUrl) {
  var defaultResponse = {
    metrics: null,
    websocket: null,
    report: null
  }; // do not attach twice (to the same websocket)

  if (element.getAttribute(VIDEO_METRICS_INITIALIZED_ATTRIBUTE) === 'true') {
    return defaultResponse;
  }

  element.setAttribute(VIDEO_METRICS_INITIALIZED_ATTRIBUTE, 'true');

  if (!window.WebSocket) {
    console.log('Browser does not support WebSocket');
    return defaultResponse;
  }

  if (!('play' in element) || !('currentTime' in element)) {
    console.log('Element provided is not a media element');
    return defaultResponse;
  }

  var metricsStatus = new MetricsStatus(element);

  try {
    var _ret = function () {
      var createNewWebSocket = function createNewWebSocket() {
        var numRetries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var newWebSocket = new WebSocket(reportingWebsocketUrl);

        newWebSocket.onopen = function () {
          // enable active statistics reporting
          report();
        };

        newWebSocket.onclose = function () {
          // disable active statistics gathering
          if (timeOut) {
            clearTimeout(timeOut);
            timeOut = null;
            enabled = false;
          } // auto-reconnect with exponential backoff


          setTimeout(function () {
            createNewWebSocket(numRetries++);
          }, Math.pow(2, numRetries) * 1e3);
        };

        return newWebSocket;
      };

      var ws = createNewWebSocket();
      var timeOut = null;
      var enabled = true; /////////////////////
      //  basics         //
      /////////////////////

      var firstPlay = function firstPlay() {
        metricsStatus.setFirstPlayback();
        element.removeEventListener('playing', firstPlay);
      };

      element.addEventListener('playing', firstPlay);
      element.addEventListener('waiting', function () {
        metricsStatus.incrementWaiting();
      });
      element.addEventListener('stalled', function () {
        metricsStatus.incrementStalled();
      });
      element.addEventListener('error', function () {
        var _element$error;

        metricsStatus.addError(element !== null && element !== void 0 && (_element$error = element.error) !== null && _element$error !== void 0 && _element$error.message ? element.error.message : 'unknown');
      }); /////////////////////
      //  playbackScore  //
      /////////////////////

      var monitor = new PlaybackMonitor(element); // enable

      var _iterator2 = _createForOfIteratorHelper(['loadstart', 'play', 'playing']),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var eventName = _step2.value;
          element.addEventListener(eventName, function () {
            monitor.init();
          });
        } // disable

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(['loadeddata', 'pause', 'abort', 'emptied', 'ended']),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _eventName = _step3.value;
          element.addEventListener(_eventName, function () {
            monitor.destroy();
          });
        } // reset

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(['seeking', 'seeked',
      /*"canplay","playing",*/
      'ratechange']),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _eventName2 = _step4.value;
          element.addEventListener(_eventName2, function () {
            monitor.reset();
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var report = function report() {
        if (!enabled) {
          return;
        } // update playback score from monitor


        var playbackScore = monitor.calculateScore();

        if (playbackScore !== null) {
          metricsStatus.setPlaybackScore(playbackScore);
        }

        var metrics = metricsStatus.getMetrics(); // only send a report if stats have changed, and only send those changes

        var d = {};
        var key;

        for (key in metrics.current) {
          var _metrics$previous;

          var val = metrics.current[key];

          if (val !== (metrics === null || metrics === void 0 ? void 0 : (_metrics$previous = metrics.previous) === null || _metrics$previous === void 0 ? void 0 : _metrics$previous[key])) {
            d[key] = val;
          }
        }

        if (Object.keys(d).length > 0) {
          send(ws, d);
        }

        timeOut = setTimeout(function () {
          report();
        }, 1e3);
      };

      return {
        v: {
          metrics: metricsStatus,
          websocket: ws,
          report: report
        }
      };
    }();

    if (_typeof(_ret) === "object") return _ret.v;
  } catch (e) {
    console.log(e);
  }

  return defaultResponse;
}

function send(webSocket, metrics) {
  if (webSocket.readyState !== webSocket.OPEN) {
    return;
  }

  webSocket.send(JSON.stringify(metrics));
}

var LP_DOMAINS = ['livepeer', 'livepeercdn', 'lp-playback'];
var PLAYLIST_NAME = 'index.m3u8';
var ASSET_URL_PART_VALUE = 'hls';
var RECORDING_URL_PART_VALUE = 'recordings'; // Example url the playback id needs to be found in
// https://livepeercdn.com/hls/<playback-id>/index.m3u8
// https://livepeercdn.com/recordings/<playback-id>/index.m3u8

var getMetricsReportingUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(src) {
    var _parts, _splitHost, _splitHost2, parsedUrl, parts, playlistPartIndex, includesAssetUrl, includesRecording, playbackId, splitHost, includesDomain, tld, tldMapped, _response$url, response, redirectedUrl;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            parsedUrl = new URL(src);
            parts = parsedUrl.pathname.split('/');
            playlistPartIndex = parts.indexOf(PLAYLIST_NAME);
            includesAssetUrl = parts.includes(ASSET_URL_PART_VALUE);
            includesRecording = parts.includes(RECORDING_URL_PART_VALUE); // Check if the url is valid

            playbackId = (includesAssetUrl || includesRecording) && playlistPartIndex !== -1 ? (_parts = parts === null || parts === void 0 ? void 0 : parts[playlistPartIndex - 1]) !== null && _parts !== void 0 ? _parts : null : null;
            splitHost = parsedUrl.host.split('.');
            includesDomain = LP_DOMAINS.includes((_splitHost = splitHost === null || splitHost === void 0 ? void 0 : splitHost[splitHost.length - 2]) !== null && _splitHost !== void 0 ? _splitHost : '');
            tld = (_splitHost2 = splitHost === null || splitHost === void 0 ? void 0 : splitHost[(splitHost === null || splitHost === void 0 ? void 0 : splitHost.length) - 1]) !== null && _splitHost2 !== void 0 ? _splitHost2 : null; // map to known TLDs, with .com => .studio

            tldMapped = tld === 'com' ? 'studio' : tld === 'studio' ? 'studio' : tld === 'fun' ? 'fun' : tld === 'monster' ? 'monster' : null; // if not a known TLD, then do not return a URL

            if (!(playbackId && includesDomain && tldMapped)) {
              _context.next = 23;
              break;
            }

            _context.prev = 12;
            _context.next = 15;
            return fetch("https://playback.livepeer.".concat(tldMapped, "/json_video+").concat(playbackId, ".js"));

          case 15:
            response = _context.sent;
            // parse the url which we're redirected to
            redirectedUrl = response === null || response === void 0 ? void 0 : (_response$url = response.url) === null || _response$url === void 0 ? void 0 : _response$url.replace('https:', 'wss:');
            return _context.abrupt("return", redirectedUrl !== null && redirectedUrl !== void 0 ? redirectedUrl : null);

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](12);
            console.log("Could not fetch metrics reporting URL.", _context.t0);

          case 23:
            _context.next = 28;
            break;

          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 28:
            return _context.abrupt("return", null);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 25], [12, 20]]);
  }));

  return function getMetricsReportingUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();

var VIDEO_HLS_INITIALIZED_ATTRIBUTE = 'data-hls-initialized';

/**
 * Checks if hls.js can play in the browser.
 */
var isHlsSupported = function isHlsSupported() {
  return IS_CLIENT ? Hls.isSupported() : true;
};
var createNewHls = function createNewHls(source, element, onLive, onDuration, onCanPlay, config) {
  // do not attach twice
  if (element.getAttribute(VIDEO_HLS_INITIALIZED_ATTRIBUTE) === 'true') {
    return {
      destroy: noop
    };
  }

  element.setAttribute(VIDEO_HLS_INITIALIZED_ATTRIBUTE, 'true');
  var hls = new Hls(_objectSpread2({
    maxBufferLength: 15,
    maxMaxBufferLength: 60
  }, config));

  var onDestroy = function onDestroy() {
    var _hls$destroy, _element$removeAttrib;

    hls === null || hls === void 0 ? void 0 : (_hls$destroy = hls.destroy) === null || _hls$destroy === void 0 ? void 0 : _hls$destroy.call(hls);
    element === null || element === void 0 ? void 0 : (_element$removeAttrib = element.removeAttribute) === null || _element$removeAttrib === void 0 ? void 0 : _element$removeAttrib.call(element, VIDEO_HLS_INITIALIZED_ATTRIBUTE);
  };

  if (element) {
    hls.attachMedia(element);
  }

  hls.on(Events.LEVEL_LOADED, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_e, data) {
      var _data$details, live, duration;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _data$details = data.details, live = _data$details.live, duration = _data$details.totalduration;
              onLive(Boolean(live));
              onDuration(duration !== null && duration !== void 0 ? duration : 0);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  hls.on(Events.MEDIA_ATTACHED, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var metricReportingUrl;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hls.loadSource(source.src);
            hls.on(Events.MANIFEST_PARSED, function (_event, _data) {
              onCanPlay();

              if (config !== null && config !== void 0 && config.autoplay && element) {
                try {
                  element.muted = true;
                } catch (e) {
                  console.log('Unable to autoplay prior to user interaction with the dom.');
                }
              }
            });
            _context2.next = 4;
            return getMetricsReportingUrl(source.src);

          case 4:
            metricReportingUrl = _context2.sent;

            if (metricReportingUrl) {
              reportMediaMetrics(element, metricReportingUrl);
            } else {
              console.log('Not able to report player metrics given the source url', source);
            }

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  var retryCount = 0;
  hls.on(Events.ERROR, /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_event, data) {
      var _data$response, _data$response$data, _data$response$data$t;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!data.fatal) {
                _context3.next = 16;
                break;
              }

              _context3.t0 = data.type;
              _context3.next = _context3.t0 === ErrorTypes.NETWORK_ERROR ? 4 : _context3.t0 === ErrorTypes.MEDIA_ERROR ? 12 : 14;
              break;

            case 4:
              if (!(data !== null && data !== void 0 && (_data$response = data.response) !== null && _data$response !== void 0 && (_data$response$data = _data$response.data) !== null && _data$response$data !== void 0 && (_data$response$data$t = _data$response$data.toString()) !== null && _data$response$data$t !== void 0 && _data$response$data$t.includes('Stream open failed'))) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return new Promise(function (r) {
                return setTimeout(r, 1000 * ++retryCount);
              });

            case 7:
              hls === null || hls === void 0 ? void 0 : hls.recoverMediaError();
              _context3.next = 11;
              break;

            case 10:
              hls === null || hls === void 0 ? void 0 : hls.startLoad();

            case 11:
              return _context3.abrupt("break", 16);

            case 12:
              hls === null || hls === void 0 ? void 0 : hls.recoverMediaError();
              return _context3.abrupt("break", 16);

            case 14:
              onDestroy();
              return _context3.abrupt("break", 16);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
  return {
    destroy: onDestroy
  };
};

var getMimeType = function getMimeType(ending) {
  for (var _i = 0, _arr = Object.keys(mime); _i < _arr.length; _i++) {
    var _mime$value;

    var value = _arr[_i];

    if ((_mime$value = mime[value]) !== null && _mime$value !== void 0 && _mime$value.some(function (v) {
      return v === ending;
    })) {
      return value;
    }
  }

  return null;
};
var mime = {
  'application/mp4': ['mp4s', 'm4p'],
  'application/ogg': ['ogx'],
  'application/vnd.apple.mpegurl': ['m3u8'],
  'audio/3gpp': ['*3gpp'],
  'audio/adpcm': ['adp'],
  'audio/amr': ['amr'],
  'audio/basic': ['au', 'snd'],
  'audio/midi': ['mid', 'midi', 'kar', 'rmi'],
  'audio/mobile-xmf': ['mxmf'],
  'audio/mp3': ['*mp3'],
  'audio/mp4': ['m4a', 'mp4a'],
  'audio/mpeg': ['mpga', 'mp2', 'mp2a', 'mp3', 'm2a', 'm3a'],
  'audio/ogg': ['oga', 'ogg', 'spx', 'opus'],
  'audio/s3m': ['s3m'],
  'audio/silk': ['sil'],
  'audio/vnd.dece.audio': ['uva', 'uvva'],
  'audio/vnd.digital-winds': ['eol'],
  'audio/vnd.dra': ['dra'],
  'audio/vnd.dts.hd': ['dtshd'],
  'audio/vnd.dts': ['dts'],
  'audio/vnd.lucent.voice': ['lvp'],
  'audio/vnd.ms-playready.media.pya': ['pya'],
  'audio/vnd.nuera.ecelp4800': ['ecelp4800'],
  'audio/vnd.nuera.ecelp7470': ['ecelp7470'],
  'audio/vnd.nuera.ecelp9600': ['ecelp9600'],
  'audio/vnd.rip': ['rip'],
  'audio/wav': ['wav'],
  'audio/wave': ['*wav'],
  'audio/webm': ['weba'],
  'audio/x-aac': ['aac'],
  'audio/x-aiff': ['aif', 'aiff', 'aifc'],
  'audio/x-caf': ['caf'],
  'audio/x-flac': ['flac'],
  'audio/x-m4a': ['*m4a'],
  'audio/x-matroska': ['mka'],
  'audio/x-mpegurl': ['m3u'],
  'audio/x-ms-wax': ['wax'],
  'audio/x-ms-wma': ['wma'],
  'audio/x-pn-realaudio-plugin': ['rmp'],
  'audio/x-pn-realaudio': ['ram', 'ra'],
  'audio/x-realaudio': ['*ra'],
  'audio/x-wav': ['*wav'],
  'audio/xm': ['xm'],
  'video/3gpp': ['3gp', '3gpp'],
  'video/3gpp2': ['3g2'],
  'video/h261': ['h261'],
  'video/h263': ['h263'],
  'video/h264': ['h264'],
  'video/iso.segment': ['m4s'],
  'video/jpeg': ['jpgv'],
  'video/jpm': ['*jpm', 'jpgm'],
  'video/mj2': ['mj2', 'mjp2'],
  'video/mp2t': ['ts'],
  'video/mp4': ['mp4', 'mp4v', 'mpg4'],
  'video/mpeg': ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v'],
  'video/ogg': ['ogv'],
  'video/quicktime': ['qt', 'mov'],
  'video/vnd.dece.hd': ['uvh', 'uvvh'],
  'video/vnd.dece.mobile': ['uvm', 'uvvm'],
  'video/vnd.dece.pd': ['uvp', 'uvvp'],
  'video/vnd.dece.sd': ['uvs', 'uvvs'],
  'video/vnd.dece.video': ['uvv', 'uvvv'],
  'video/vnd.dvb.file': ['dvb'],
  'video/vnd.fvt': ['fvt'],
  'video/vnd.mpegurl': ['mxu', 'm4u'],
  'video/vnd.ms-playready.media.pyv': ['pyv'],
  'video/vnd.uvvu.mp4': ['uvu', 'uvvu'],
  'video/vnd.vivo': ['viv'],
  'video/webm': ['webm'],
  'video/x-f4v': ['f4v'],
  'video/x-fli': ['fli'],
  'video/x-flv': ['flv'],
  'video/x-m4v': ['m4v'],
  'video/x-matroska': ['mkv', 'mk3d', 'mks'],
  'video/x-mng': ['mng'],
  'video/x-ms-asf': ['asf', 'asx'],
  'video/x-ms-vob': ['vob'],
  'video/x-ms-wm': ['wm'],
  'video/x-ms-wmv': ['wmv'],
  'video/x-ms-wmx': ['wmx'],
  'video/x-ms-wvx': ['wvx'],
  'video/x-msvideo': ['avi'],
  'video/x-sgi-movie': ['movie'],
  'video/x-smv': ['smv']
};

var audioExtensions = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var videoExtensions = /\.(mp4|ogv|webm|mov|m4v|avi|m3u8)($|\?)/i;
var hlsExtensions = /\.(m3u8)($|\?)/i;
var getMediaSourceType = function getMediaSourceType(src) {
  var _hlsExtensions$exec$, _hlsExtensions$exec, _videoExtensions$exec, _videoExtensions$exec2, _audioExtensions$exec, _audioExtensions$exec2;

  return hlsExtensions.test(src) ? {
    type: 'hls',
    src: src,
    mime: getMimeType((_hlsExtensions$exec$ = (_hlsExtensions$exec = hlsExtensions.exec(src)) === null || _hlsExtensions$exec === void 0 ? void 0 : _hlsExtensions$exec[1]) !== null && _hlsExtensions$exec$ !== void 0 ? _hlsExtensions$exec$ : '')
  } : videoExtensions.test(src) ? {
    type: 'video',
    src: src,
    mime: getMimeType((_videoExtensions$exec = (_videoExtensions$exec2 = videoExtensions.exec(src)) === null || _videoExtensions$exec2 === void 0 ? void 0 : _videoExtensions$exec2[1]) !== null && _videoExtensions$exec !== void 0 ? _videoExtensions$exec : '')
  } : audioExtensions.test(src) ? {
    type: 'audio',
    src: src,
    mime: getMimeType((_audioExtensions$exec = (_audioExtensions$exec2 = audioExtensions.exec(src)) === null || _audioExtensions$exec2 === void 0 ? void 0 : _audioExtensions$exec2[1]) !== null && _audioExtensions$exec !== void 0 ? _audioExtensions$exec : '')
  } : null;
}; // Taken from video.js
// const _hlsTypes = new Set([
//   // Apple sanctioned
//   'application/vnd.apple.mpegurl',
//   // Apple sanctioned for backwards compatibility
//   'audio/mpegurl',
//   // Very common
//   'audio/x-mpegurl',
//   // Very common
//   'application/x-mpegurl',
//   // Included for completeness
//   'video/x-mpegurl',
//   'video/mpegurl',
//   'application/mpegurl',
// ]);

var _createStitches = createStitches({
  media: {
    sm: '(min-width: 640px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)'
  },
  theme: {
    borderStyles: {
      containerBorderStyle: 'hidden'
    },
    borderWidths: {
      containerBorderWidth: 0,
      loadingWidth: '3px'
    },
    colors: {
      accent: '#00a55f',
      background: '#000000',
      containerBorderColor: 'transparent',
      icon: 'rgba(255,255,255,1)',
      iconHover: 'rgba(255,255,255,0.8)',
      liveIndicator: '#e5484d'
    },
    fonts: {
      display: 'ui-sans-serif'
    },
    fontSizes: {
      timeFontSize: '1.0rem',
      timeFontSizeMd: '0.95rem',
      timeFontSizeSm: '0.85rem',
      titleFontSize: '1.1rem',
      titleFontSizeMd: '1rem',
      titleFontSizeSm: '0.9rem'
    },
    fontWeights: {
      titleFontWeight: 400
    },
    shadows: {
      containerShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
      containerShadowHover: '$containerShadow'
    },
    sizes: {
      iconButtonSize: '42px',
      iconButtonSizeSm: '36px',
      liveIndicatorSize: '5px',
      loading: '64px',
      thumb: '12px',
      trackActive: '5px',
      trackContainerHeight: '15px',
      trackContainerHeightSm: '20px',
      trackInactive: '3px'
    },
    space: {
      controlsBottomMarginX: '10px',
      controlsBottomMarginY: '5px',
      controlsTopMarginX: '15px',
      controlsTopMarginY: '10px',
      timeMarginX: '8px'
    },
    radii: {
      containerBorderRadius: '5px',
      slider: '3px'
    }
  }
}),
    css = _createStitches.css,
    createPlayerTheme = _createStitches.createTheme,
    defaultTheme = _createStitches.theme,
    getCssText = _createStitches.getCssText;

var scaleUp = keyframes({
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(1.1)'
  }
});
var iconButton = css('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  outline: 'inherit',
  padding: 0,
  height: '$iconButtonSizeSm',
  width: '$iconButtonSizeSm',
  minHeight: '$iconButtonSizeSm',
  minWidth: '$iconButtonSizeSm',
  '@lg': {
    height: '$iconButtonSize',
    width: '$iconButtonSize',
    minHeight: '$iconButtonSize',
    minWidth: '$iconButtonSize'
  },
  color: '$icon',
  '&:hover': {
    color: '$iconHover',
    animation: !IS_MOBILE ? "".concat(scaleUp, " 200ms") : undefined
  }
});

var _aspectRatio;
var aspectRatios = [{
  key: '16to9',
  value: '16 / 9'
}, {
  key: '1to1',
  value: '1 / 1'
}, {
  key: '9to16',
  value: '9 / 16'
}, {
  key: '4to5',
  value: '4 / 5'
}, {
  key: '21to9',
  value: '21 / 9'
}];
var aspectRatioContainer = css('div', {
  variants: {
    aspectRatio: (_aspectRatio = {}, _defineProperty(_aspectRatio, aspectRatios[0].key, _defineProperty({
      aspectRatio: aspectRatios[0].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[0].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[0].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[1].key, _defineProperty({
      aspectRatio: aspectRatios[1].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[1].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[1].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[2].key, _defineProperty({
      aspectRatio: aspectRatios[2].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[2].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[2].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[3].key, _defineProperty({
      aspectRatio: aspectRatios[3].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[3].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[3].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[4].key, _defineProperty({
      aspectRatio: aspectRatios[4].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[4].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[4].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _aspectRatio)
  }
});
var container$3 = css(aspectRatioContainer, {
  fontFamily: '$display, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
  backgroundColor: '$background',
  overflow: 'hidden',
  maxWidth: '100%',
  maxHeight: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  svg: {
    pointerEvents: 'none'
  },
  // for iOS rendering custom controls
  zIndex: 2147483647,
  variants: {
    size: {
      fullscreen: {},
      default: {
        '&:hover': {
          boxShadow: '$containerShadowHover'
        },
        boxShadow: '$containerShadow',
        borderStyle: '$containerBorderStyle',
        borderColor: '$containerBorderColor',
        borderRadius: '$containerBorderRadius',
        borderWidth: '$containerBorderWidth'
      }
    }
  },
  defaultVariants: {
    size: 'default'
  }
});

var rotate = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
var loading = css('div', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  maxWidth: '100%',
  maxHeight: '100%',
  '&:after': {
    content: ' ',
    display: 'block',
    width: '$loading',
    height: '$loading',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '50%',
    borderWidth: '$loadingWidth',
    borderStyle: 'solid',
    borderColor: '$accent transparent $accent transparent',
    animation: "".concat(rotate, " 1.4s ease-in-out infinite")
  }
});

var hidden = keyframes({
  '0%': {
    opacity: 1
  },
  '100%': {
    opacity: 0
  }
});
var shown = keyframes({
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
var sharedContainer = css('div', {
  variants: {
    display: {
      shown: {
        opacity: 1,
        animation: !IS_MOBILE ? "".concat(shown, " 0.2s") : undefined
      },
      hidden: {
        opacity: 0,
        animation: !IS_MOBILE ? "".concat(hidden, " 0.2s") : undefined
      }
    }
  },
  defaultVariants: {
    display: 'shown'
  }
});
var background = css(sharedContainer, {
  position: 'absolute',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  height: '100%'
});
var gradient = css(sharedContainer, {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: 233,
  marginBottom: -1,
  maxWidth: '100%',
  maxHeight: '100%',
  overflow: 'hidden',
  backgroundImage: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADpCAYAAADlAl1mAAAAAXNSR0IArs4c6QAAAexJREFUOE9V0ftrzXEcx/H3x+43l9lmGGaz65ld2YUZG2YYKUlJUpKSpNZSkpSkJClJSVKSkj9Sj8/3nJ12fnie5/v9en/en+/3nIjik6rfNOU6YwfJqNGp0ctWGylSLavTqzNe72S9YYgGaYOysYJodKxJ2uSeZseaC4uUWpQt0lbWWlhEtFnVZv1O5RbSLkHGbifKiBR7XJnR7kS7dG+BSNlSh7TDvZ02d5rL6DLXxfYZriCiW69bbz+rIKUDyoyDW+hxB0RPpJQOCTIOb8cRZUavB+r1QCyOVpD6WJ97s/Wb67f5GINsMaA3YG6QDbIh7zZUWEQaNjesHHHRiB7EqLlRx0qsZKQkHdMb0zturopx5bhgwqoJJaRJNmnBlGBKj8W0YNq+GTbjFzrBqjipzJh1bNYxFnNsjs1bMF9YpFhgC3qnCkQkiNMMYlGwqDzDyoiIJc+35O85a66MFHFOmbHsjmVnM1Y884rgvLKClC4oIS5ux6pg1ZZLgow1v9pa2SIus4wrBVKkbFedhVhn67Zku2bBdcENr3CT3ZLe9oJ32F12T3DfCz7QewiP9B7b8kT5VPmMbVi6yZ7DCwtemnvFXrvoDXtr7p3gPXxQfhR8suqz8gv7Kv3mZb5Lf+j91PvFfsMf+Av//gMAXDGpZ05jKQAAAABJRU5ErkJggg==")'
});
var topContainer = css(sharedContainer, {
  top: 0,
  marginTop: '$controlsTopMarginY',
  marginBottom: '$controlsTopMarginY',
  marginLeft: '$controlsTopMarginX',
  marginRight: '$controlsTopMarginX',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'absolute',
  left: 0,
  right: 0
});
var bottomContainer = css(sharedContainer, {
  justifyContent: 'center',
  bottom: 0,
  marginTop: '$controlsBottomMarginY',
  marginBottom: '$controlsBottomMarginY',
  marginLeft: '$controlsBottomMarginX',
  marginRight: '$controlsBottomMarginX',
  display: 'inline-flex',
  alignItems: 'center',
  position: 'absolute',
  flexDirection: 'column',
  left: 0,
  right: 0
});
var spaceBetweenContainer = css('div', {
  width: '100%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});
var right$1 = css(spaceBetweenContainer, {
  width: 'auto'
});
var left$1 = css(spaceBetweenContainer, {
  width: 'auto'
});
var controlsContainer = {
  background: background,
  gradient: gradient,
  loading: loading,
  top: {
    container: topContainer
  },
  bottom: {
    container: bottomContainer,
    middle: {
      container: spaceBetweenContainer
    },
    lower: {
      container: spaceBetweenContainer,
      left: left$1,
      right: right$1
    }
  }
};

var poster = css('img', {
  maxWidth: '100%',
  width: '100%',
  maxHeight: '100%',
  height: '100%',
  pointerEvents: 'none',
  userSelect: 'none',
  objectPosition: 'center',
  objectFit: 'cover',
  variants: {
    size: {
      fullscreen: {
        width: '100% !important',
        height: '100% !important'
      },
      default: {}
    }
  },
  defaultVariants: {
    size: 'default'
  }
});
var video = css('video', {
  width: '100% !important',
  height: '100% !important',
  objectPosition: 'center',
  variants: {
    size: {
      fullscreen: {
        objectFit: 'contain',
        '&::-webkit-media-overlay-enclosure': {
          display: 'none !important'
        },
        '&::-webkit-media-controls-enclosure': {
          display: 'none !important'
        }
      },
      contain: {
        objectFit: 'contain'
      },
      cover: {
        objectFit: 'cover'
      }
    }
  },
  defaultVariants: {
    size: 'cover'
  }
});
var audio = css('audio', video);
var media = {
  audio: audio,
  poster: poster,
  video: video
};

var expand = keyframes({
  '0%': {
    height: '$trackInactive'
  },
  '100%': {
    height: '$trackActive'
  }
});
var contract = keyframes({
  '0%': {
    height: '$trackActive'
  },
  '100%': {
    height: '$trackInactive'
  }
});
var container$2 = css('div', {
  minHeight: '$trackContainerHeightSm',
  '@lg': {
    minHeight: '$trackContainerHeight'
  },
  '@media (hover: none)': {
    minHeight: '$trackContainerHeightSm'
  },
  display: 'flex',
  alignItems: 'center',
  minWidth: 80,
  touchAction: 'none',
  cursor: 'pointer',
  height: '100%',
  width: '100%'
});
var sharedTrack = css('div', {
  variants: {
    size: {
      default: {
        height: '$trackInactive',
        animation: "".concat(contract, " 0.1s")
      },
      active: {
        height: '$trackActive',
        animation: "".concat(expand, " 0.1s")
      }
    },
    rounded: {
      full: {
        borderRadius: '$slider'
      },
      left: {
        borderTopLeftRadius: '$slider',
        borderBottomLeftRadius: '$slider'
      },
      right: {
        borderTopRightRadius: '$slider',
        borderBottomRightRadius: '$slider'
      },
      none: {}
    }
  },
  defaultVariants: {
    size: 'default',
    rounded: 'none'
  }
});
var left = css(sharedTrack, {
  backgroundColor: '$accent',
  opacity: 0.95
});
var middle = css(sharedTrack, {
  backgroundColor: '$accent',
  opacity: 0.55
});
var right = css(sharedTrack, {
  backgroundColor: '$accent',
  opacity: 0.2
});
var thumb = css('div', {
  width: '$thumb',
  height: '$thumb',
  backgroundColor: '$icon',
  borderRadius: '100%'
});
var slider = {
  container: container$2,
  thumb: thumb,
  track: {
    left: left,
    middle: middle,
    right: right
  }
};

var text = css('span', {
  color: '$icon',
  userSelect: 'none'
});

var container$1 = css('div', {
  display: 'flex',
  alignItems: 'center'
});
var liveIndicator = css('div', {
  backgroundColor: '$liveIndicator',
  borderRadius: '100%',
  width: '$liveIndicatorSize',
  height: '$liveIndicatorSize'
});
var timeText = css(text, {
  marginLeft: '$timeMarginX',
  marginRight: '$timeMarginX',
  fontVariant: 'tabular-nums',
  fontSize: '$timeFontSizeSm',
  '@md': {
    fontSize: '$timeFontSizeMd'
  },
  '@lg': {
    fontSize: '$timeFontSize'
  }
});
var time = {
  container: container$1,
  text: timeText,
  liveIndicator: liveIndicator
};

var title = css(text, {
  fontWeight: '$titleFontWeight',
  fontSize: '$titleFontSizeSm',
  '@md': {
    fontSize: '$titleFontSizeMd'
  },
  '@lg': {
    fontSize: '$titleFontSize'
  }
});

var container = css('div', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
});
var volume = {
  container: container
};

var styling = {
  container: container$3,
  controlsContainer: controlsContainer,
  iconButton: iconButton,
  media: media,
  slider: slider,
  time: time,
  title: title,
  volume: volume
};

export { Client, MetricsStatus, PlaybackMonitor, addEventListeners, canPlayMediaNatively, createAsset, createClient, createControllerStore, createNewHls, createPlayerTheme, createStorage, createStream, deepMerge, defaultTheme, getAsset, getAssetMetrics, getCssText, getLivepeerProvider, getMediaSourceType, getMetricsReportingUrl, getPlaybackInfo, getStream, getStreamSession, getStreamSessions, isHlsSupported, noopStorage, pick, reportMediaMetrics, styling, updateAsset, updateStream, watchLivepeerProvider };
